import { defineStore } from "pinia";
import { ref } from "vue";
import { fetchFileSources } from "@/api/remoteFiles";
export const useFileSourcesStore = defineStore("fileSourcesStore", () => {
    const cachedFileSources = ref({});
    async function getFileSources(options = {}) {
        const cacheKey = getCacheKey(options);
        if (cachedFileSources.value[cacheKey] === undefined) {
            cachedFileSources.value[cacheKey] = fetchFileSources(options);
        }
        if (cachedFileSources.value[cacheKey] instanceof Promise) {
            cachedFileSources.value[cacheKey] = await cachedFileSources.value[cacheKey];
        }
        return cachedFileSources.value[cacheKey];
    }
    function getCacheKey(options) {
        return JSON.stringify(options);
    }
    return {
        getFileSources,
    };
});
